/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Logout request
 * @export
 * @interface LogoutRequest
 */
export interface LogoutRequest {
    /**
     * 
     * @type {string}
     * @memberof LogoutRequest
     */
    refreshToken?: string;
    /**
     * 
     * @type {string}
     * @memberof LogoutRequest
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogoutRequest
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogoutRequest
     */
    tokenId?: string;
}

/**
 * Check if a given object implements the LogoutRequest interface.
 */
export function instanceOfLogoutRequest(value: object): value is LogoutRequest {
    return true;
}

export function LogoutRequestFromJSON(json: any): LogoutRequest {
    return LogoutRequestFromJSONTyped(json, false);
}

export function LogoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogoutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'refreshToken': json['refresh_token'] == null ? undefined : json['refresh_token'],
        'clientId': json['client_id'] == null ? undefined : json['client_id'],
        'sessionId': json['session_id'] == null ? undefined : json['session_id'],
        'tokenId': json['token_id'] == null ? undefined : json['token_id'],
    };
}

export function LogoutRequestToJSON(json: any): LogoutRequest {
    return LogoutRequestToJSONTyped(json, false);
}

export function LogoutRequestToJSONTyped(value?: LogoutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refresh_token': value['refreshToken'],
        'client_id': value['clientId'],
        'session_id': value['sessionId'],
        'token_id': value['tokenId'],
    };
}

